import React, { FC } from 'react'
import { IonModal, IonHeader } from '@ionic/react'
import { observer } from 'mobx-react'
import { getPlatform } from '@utils'
import { wxConfigG } from 'controllers/third'
import i18n from 'i18next'
import './index.scss'

const { isWeixin, isAlipay, isWeixinMiniProgram } = getPlatform()

type TContactType = 'mobile' | 'email' | 'wechatMini' | 'wechat'
interface IProps {
  title?: string;
  hasThird?: boolean;
  reject?: () => void;
  resolve?: (type: TContactType) => void;
}

const VerificationType: FC<IProps> = (props) => {
  const { title, hasThird, reject, resolve } = props
  const typeArr: any[] = [
    {
      label: i18n.t('mkt.coupon.msgFor'),
      value: 'mobile',
      icon: 'icon-duanxin'
    },
    {
      label: i18n.t('mkt.coupon.emailFor'),
      value: 'email',
      icon: 'icon-youjian'
    }
  ]
  if (hasThird) {
    if (isWeixinMiniProgram) {
      typeArr.push({
        label: i18n.t('mkt.coupon.wechatFor'),
        value: 'wechatMini',
        icon: 'icon-weixin1'
      })
    } else if ((isWeixin && wxConfigG.isInited())) {
      typeArr.push({
        label: i18n.t('mkt.coupon.wechatFor'),
        value: 'wechat',
        icon: 'icon-weixin1'
      })
    }
    // if (isAlipay) {
    //   typeArr.push({
    //     label: i18n.t('pay.alipay'),
    //     value: 'alipay',
    //     icon: 'icon-zhifubaozhifu'
    //   })
    // }
  }
  return (
    <IonModal
      cssClass='coupon-give-type-modal'
      isOpen
      onDidDismiss={reject}
    >
      <IonHeader className='modal-header'>
        <span className='title'>{title || i18n.t('mkt.coupon.couponMethod')}</span>
        <div data-cypid='mmgCloseGCardGiveType' className='right' onClick={reject}>
          <i className='iconfont icon-close'></i>
        </div>
      </IonHeader>
      <div className='modal-content'>
        {
          typeArr.map((item: any, index: number) => {
            return (
              <div data-cypid='mmgSelectGCardGiveType' key={index} className='give-item' onClick={() => resolve && resolve(item.value)}>
                <div className='give-area'>
                  <i className={`iconfont ${item.icon}`}></i>
                  <div className='give-area-text'>{item.label}</div>
                </div>
              </div>
            )
          })
        }
      </div>
    </IonModal>
  )
}

export default observer(VerificationType)
